<template>
    <div class="caseFiji">
      <Helmet>
        <title>How inte-QT Overcame COVID-19 Challenges to Deliver a Dedicated Internet Line in Argentina</title>
        <meta name="title" content="How inte-QT Overcame COVID-19 Challenges to Deliver a Dedicated Internet Line in Argentina" />
        <meta name="description" :content="cases[2].title" />
        <link rel="canonical" href="https://www.inte-qt.com/cases/argentina" />
      </Helmet>
  
      <img :src="cases[2].img" alt="bigbanner-background" class="banner-img banner-img__black" />
      <h1 class="banner-img__header text-center">{{ cases[2].title }}</h1>
  
      <div class="container-fluid caseFiji">
        <div class="container">
          
          <div class="caseFiji2__width my-5">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/847uR6R.png"
                alt="technology-head"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Key Challenges Faced During Service Delivery</h2>
            </div>
            <ul>
              <li><strong>Rapid Deployment Requirements:</strong> Ensuring quick service delivery amidst strict COVID-19 regulations.</li>
              <li><strong>Stringent Health and Safety Compliance:</strong> Meeting strict health guidelines during installation.</li>
              <li><strong>High Standards for Quality of Service:</strong> Maintaining exceptional service quality in a remote location.</li>
            </ul>
          </div>
  
          
          <div class="caseFiji2__width my-5 caseFiji2__margin">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/4s6vXof.png"
                alt="wireless-signal"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Effective Solutions Implemented to Meet Customer Needs</h2>
            </div>
            <ul>
              <li>Strict adherence to COVID-19 protocols ensured safety for all parties involved.</li>
              <li>Collaboration with reliable partners guaranteed compliance with health and safety regulations.</li>
              <li>A robust network design exceeded customer expectations as part of the inte-Qt Dedicated Line service.</li>
            </ul>
          </div>
  
          
          <div class="caseFiji2__width my-5">
            <div class="caseFiji2__space m-4">
              <img
                src="/images/55CYPwa.png"
                alt="devices-red"
                class="caseFiji2__icon mx-3"
              />
              <h2 class="pt-4">Outstanding Outcomes Achieved for Our Client</h2>
            </div>
            <ul>
              <li>Customer delighted with early delivery, meeting all regulatory compliance.</li>
              <li>Exceeded quality of service parameters, enhancing overall customer satisfaction.</li>
            </ul>
          </div>
  
          
          <h2 class="my-5">Background of the Case</h2>
          <p align="justify">
            In early 2021, inte-QT faced the challenge of delivering a dedicated internet line for a Fortune 500 FMCG company in Argentina during a resurgence of COVID-19. The customer expected deployment amid strict regulations and compliance requirements.
          </p>
          <img
            src="/images/mifydW7.jpg"
            alt="light-beach"
            class="caseFiji2__textimg caseFiji2__right m-3"
          />
          <p align="justify">
            At the time, the customer requested specific compliance documents related to COVID-19 health and safety for site access, which were critical for our partner’s survey and installation teams. Understanding the importance of maintaining high-quality service parameters, we prioritized compliance while ensuring robust bandwidth, low latency, and reliable service delivery.
          </p>
  
          
          <h2 class="my-5">Solution</h2>
          <p align="justify">
            Given the customer's confidence in inte-QT based on previous successful projects, we quickly engaged with them to address their urgent needs. Our strong partner network in Latin America, aligned with COVID-19 regulations, allowed us to meet the delivery timeline.
          </p>
          <p align="justify">
            Our operations team collaborated closely with both the partner and the customer to finalize the delivery framework. Effective communication was key; we assigned a dedicated resource to facilitate timely delivery through virtual meetings and discussions.
          </p>
  
          <img
            src="/images/rMUNic4.jpg"
            class="caseFiji2__textimg caseFiji2__left m-3"
            alt="team-collaboration"
          />
  
          
          <h2 class="my-5">Outcome</h2>
          <p align="justify">
            Despite the challenges posed by the pandemic, we successfully delivered the service ahead of schedule while maintaining high-quality parameters. The network design not only met but exceeded the expectations of our client.
          </p>
          <p align="justify">
            Stringent redundancy measures were implemented to avoid any major impact on the user's operations, resulting in high customer satisfaction and delight.
          </p>
  
          
          <div class="cases__box">
            <div class="row">
              <div class="col-lg-6 col-md-12">
                <h2 class="cases__companyName mx-3">{{ cases[1].title }}</h2>
                <p class="cases__text m-3" align="justify">
                  {{ cases[1].p3 }}
                </p>
                <div class="text-end mx-3">
                  <DinamicLink :url="'/cases/lebanon'" name="Read more" />
                </div>
              </div>
              <div class="col-lg-6 col-md-12">
                <img :src="cases[1].img" alt="Description of the case" class="cases__img" />
              </div>
            </div>
          </div>
        </div>
      </div>
  
      <GetInTouch />
    </div>
  </template>
  
  <script>
  import DinamicLink from '@/components/DinamicLink';
  import GetInTouch from '@/components/GetInTouch';
  import { Helmet } from 'vue-helmet'; 
  
  export default {
    name: 'CasesColgate',
    components: {
      DinamicLink,
      GetInTouch,
      Helmet
    },
    data() {
      return {
        cases: require('@/data/casesInfo.json')
      };
    },
    mounted() {
      window.scrollTo(0, 0);
    }
  };
  </script>
  
  <style scoped>
  .caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
   ul {
    margin-top: 0;
    margin-bottom: 1rem;
    text-align: -webkit-left;
  
  }
  
  .caseFiji__aux {
    padding: 5rem 12rem;
  }
  
  .caseFiji__space {
    margin-top: 6rem;
  }

  caseFiji {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji2__width {
    margin: 1rem;
  }
  
  .caseFiji2__space {
    display: flex;
    align-items: center;
  }
  
  .caseFiji2__icon {
    max-width: 50px;
    max-height: 50px;
  }
  
  .caseFiji2__textimg {
    width: 100%;
    margin: 1rem;
  }
  
  .banner-img {
    width: 100%;
  }
  
  .banner-img__black {
    background-color: black;
  }
  
  .banner-img__header {
    position: absolute;
    top: 45vh;
    left: 50vw;
    transform: translateX(-50%) translateY(-50%);
    font-size: 4rem;
    font-weight: bold;
    color: white;
    text-align: center;
  }
  
  ul {
    list-style-type: disc;
    padding-left: 2rem;
  }
  
  ul li {
    margin-bottom: 0.5rem;
  }
  
  .cases__box {
    margin-top: 3rem;
  }
  
  .cases__companyName {
    font-size: 2rem;
    font-weight: bold;
  }
  
  .cases__text {
    text-align: justify;
    font-size: 1.2rem;
  }
  
  .cases__img {
    max-width: 100%;
  }
  
  .text-end {
    text-align: right;
  }
  
  .mx-3 {
    margin-left: 1rem;
    margin-right: 1rem;
  }
  
  @media screen and (max-width: 768px) {
    .banner-img__header {
      font-size: 2.5rem;
      top: 30vh;
    }
  }
  
  @media (max-width: 768px) {
    .caseFiji {
      line-height: 1.2;
      margin-top: 0rem;
    }
  
    .caseFiji__title {
      margin: 1rem;
    }
  
    .caseFiji__aux {
      padding: 1rem;
    }
  }
  .caseFiji2 {
    color: black;
    line-height: 1.5;
    margin-top: 5rem;
  }
  
  .caseFiji2__title {
    position: absolute;
    width: 40vw;
    top: 45vh;
    left: 55vw;
    line-height: 1.5;
    font-size: 4rem;
    font-weight: bold;
    color: white;
  }
  
  .caseFiji2__icon {
    width: 75px;
  }
  
  .caseFiji2__textimg {
    width: 500px;
  }
  
  .caseFiji2__lastimg {
    width: 100%;
  }
  
  .caseFiji2__space {
    display: flex;
  }
  
  .caseFiji2__width {
    width: 40vw;
  }
  
  .caseFiji2__right {
    float: right;
  }
  
  .caseFiji2__left {
    float: left;
  }
  
  .caseFiji2__margin {
    margin-left: 45%;
  }
  
  @media (max-width: 768px) {
    .caseFiji2__title {
      font-size: 3rem;
      top: 30vh;
      left: 55vw;
    }
  
    .caseFiji2__icon {
      width: 60px;
    }
  
    .caseFiji2__textimg {
      width: 80vw;
    }
  
    .caseFiji2__width {
      width: auto;
    }
  
    .caseFiji2__margin {
      margin-left: 53%;
    }
  }
  
  @media (max-width: 480px) {
    .caseFiji2__title {
      font-size: 1.5rem;
      top: 12vh;
      left: 5vw;
      width: 90vw;
    }
  
    .caseFiji2__icon {
      width: 50px;
    }
  }
  </style>
  